<h2 mat-dialog-title>Submit</h2>

    <mat-dialog-content>
      <div class="dialog-content-container">
   
        @if (hasError) {
          <mat-card class="error-card">
            <mat-card-content>
              <p class="error-message">
                Uh oh! Unfortunately we have experienced an error<br />
                Details: {{ errorMessage }}
              </p>
            </mat-card-content>
          </mat-card>
        }

        @if (isSaving) {
          <div class="loading-container">
            <mat-spinner diameter="60"></mat-spinner>
            <p>Submitting your form...</p>
          </div>
        }

        @if (success) {
          <div class="success-container">
            <mat-icon class="success-icon">check_circle</mat-icon>
            <p>Form submitted successfully!</p>
          </div>
        }
      </div>
    </mat-dialog-content>
      <mat-dialog-actions align="end">
        @if (!isSaving) {
          <button mat-flat-button type="button" (click)="close()">Close</button>
        }
      </mat-dialog-actions>
